/** Événement du scan capté par le cadre du PDA, reçu par la page Mode Stock (detail = code). */
export const PDA_SCAN_EVENT = 'vp-pda-scan';

export const dispatchPdaScan = (code: string): void => {
  window.dispatchEvent(new CustomEvent<string>(PDA_SCAN_EVENT, { detail: code }));
};
